import "core-js/modules/es.array.map";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { serverRetentionByTierDetail, accountOrDeviceRetainDetail, tierRetentionDetail, tierRetentionDetailCurrency } from "@/api/dataAll/accountRetain";
import { serchSelect, tabulation, gmToolNewPage, gmTool } from "@/mixins/index";
export default {
  name: 'watchBackPackDetails',
  mixins: [serchSelect, tabulation, gmToolNewPage, gmTool],
  data: function data() {
    return {
      dialogShow: false,
      dialogLoading: false,
      tableData: [],
      paramsData: {},
      labelName: '',
      allDate: []
    };
  },
  created: function created() {},
  methods: {
    init: function init(data) {
      this.paramsData = data;
      this.dialogShow = true;
      this.searchList();
    },
    searchList: function searchList() {
      var _this = this;

      this.dialogLoading = true;
      var reqFn = "";
      var otherParam = {};

      if (this.paramsData.key == "serverRoleRetain") {
        this.labelName = '角色ID';
        reqFn = serverRetentionByTierDetail;
      }

      if (this.paramsData.key == "accountRetain" || this.paramsData.key == "deviceRetain" || this.paramsData.key == "payAccountRetain") {
        this.labelName = '用户ID';
        reqFn = accountOrDeviceRetainDetail;
      }

      if (this.paramsData.key == "userSsegmentationRetention") {
        this.labelName = '用户ID';
        var searchCurrency = this.$store.state.d2admin.serchSelect.searchCurrency;
        reqFn = searchCurrency.length ? tierRetentionDetailCurrency : tierRetentionDetail;
        this.allDate = [this.paramsData.start_date, this.paramsData.end_date];
      }

      if (this.paramsData.key == "accountRetain") {
        otherParam = {
          type: "user"
        };
      }

      if (this.paramsData.key == "deviceRetain") {
        this.labelName = '设备ID';
        otherParam = {
          type: "device"
        };
      }

      if (this.paramsData.key == "payAccountRetain") {
        otherParam = {
          type: "user",
          pay: true
        };
      }

      reqFn(_objectSpread(_objectSpread({}, this.paramsData), otherParam)).then(function (res) {
        _this.dialogLoading = false;
        console.log("res==", res);

        if (res.status == 200) {
          var data = res.data.list || [];
          var newData = data.map(function (item) {
            return {
              user_id: item
            };
          });
          _this.tableCopyTableList = JSON.parse(JSON.stringify(newData));
          _this.tableData = _this.currentChangePage(_this.pageSize, _this.currentPage);
        }
      });
    },
    userDateChang: function userDateChang(e) {
      this.paramsData.start_date = e[0];
      this.paramsData.end_date = e[1];
    },
    exportdata: function exportdata() {
      var columns = [{
        label: '用户ID',
        prop: 'user_id'
      }];
      this.$export.excel({
        columns: columns,
        data: this.tableCopyTableList,
        title: this.$route.meta.title
      });
    }
  }
};